export const lockScreen = (lock, time) =>
  setTimeout(() => {
    const blocker = document.getElementById('wdgy-body-scroll-blocker');
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = lock ? 'hidden' : '';
    blocker.style.display = lock ? 'initial' : '';
  }, time);
